var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { arrayMove } from "@dnd-kit/sortable";
import styled, { useTheme } from "styled-components";
import { border, color, maxWidth, minWidth, width, } from "styled-system";
// needed for table body level scope DnD setup
import { closestCenter, DndContext, KeyboardSensor, MouseSensor, TouchSensor, useSensor, useSensors, } from "@dnd-kit/core";
import { restrictToHorizontalAxis } from "@dnd-kit/modifiers";
import { StatusMessage } from "./StatusMessage";
const StyledTable = styled.table `
  ${color}
  ${border}
  ${width}
  ${maxWidth}
  ${minWidth}

  border-collapse: collapse;
`;
StyledTable.defaultProps = {
    cellPadding: 0,
};
const TableContainer = styled.div `
  overflow: auto;
  width: 100%;

  /* Prevent corners from overflowing when Table is rendered within a Card component */
  &:last-child {
    border-bottom-left-radius: var(--card-border-radius, "0px");
    border-bottom-right-radius: var(--card-border-radius, "0px");
  }
`;
export const Table = (_a) => {
    var { errorMessage, setColumnOrder } = _a, rest = __rest(_a, ["errorMessage", "setColumnOrder"]);
    const { colors: { tableColors }, } = useTheme();
    // reorder columns after drag & drop
    const handleDragEnd = (event) => {
        const { active, over } = event;
        if (active && over && active.id !== over.id) {
            setColumnOrder((columnOrder) => {
                const oldIndex = columnOrder.indexOf(active.id);
                const newIndex = columnOrder.indexOf(over.id);
                return arrayMove(columnOrder, oldIndex, newIndex); // this is just a splice util
            });
        }
    };
    const sensors = useSensors(useSensor(MouseSensor, {}), useSensor(TouchSensor, {}), useSensor(KeyboardSensor, {}));
    return (React.createElement(DndContext, { collisionDetection: closestCenter, modifiers: [restrictToHorizontalAxis], onDragEnd: handleDragEnd, sensors: sensors },
        React.createElement(TableContainer, null,
            errorMessage && React.createElement(StatusMessage, null, errorMessage),
            React.createElement(StyledTable, Object.assign({ backgroundColor: tableColors.tableBackground }, rest)))));
};
